var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _path3, _polygon, _circle, _path4, _rect6, _rect7, _rect8, _rect9, _circle2, _path5, _path6, _path7, _path8, _path9, _rect0, _rect1, _rect10, _rect11, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVitalRadarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    id: "vital-sign",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#999a9e",
    d: "M58,7H6a4,4,0,0,0-4,4V45a4,4,0,0,0,4,4H58a4,4,0,0,0,4-4V11A4,4,0,0,0,58,7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#b3b4b8",
    d: "M58,7H8V40a4,4,0,0,0,4,4H62V11A4,4,0,0,0,58,7Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 34,
    x: 6,
    y: 11,
    fill: "#6ac4e8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 33,
    x: 8,
    y: 11,
    fill: "#b3ddeb"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 20,
    x: 6,
    y: 11,
    fill: "#f1f1f1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    x: 18,
    y: 49,
    fill: "#5a5b5d"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    x: 42,
    y: 49,
    fill: "#5a5b5d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2d76a7",
    d: "M16,28l-.071,0a1,1,0,0,1-.913-.819L13.638,19.6l-.709,1.774A1,1,0,0,1,12,22H6V20h5.323l1.748-4.372a1,1,0,0,1,1.913.193l1.3,7.16,2.765-8.3A.989.989,0,0,1,20.078,14a1,1,0,0,1,.908.832L21.847,20H26a1,1,0,0,1,.949.684l1.136,3.41,2.986-7.466a1,1,0,0,1,1.9.129L33.781,20H40v2H33a1,1,0,0,1-.97-.757l-.25-1-2.851,7.129a.977.977,0,0,1-.958.628,1,1,0,0,1-.92-.684L25.279,22H21a1,1,0,0,1-.986-.835l-.339-2.029-2.726,8.18A1,1,0,0,1,16,28Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#999a9e",
    points: "39 11 39 30 6 30 6 32 21 32 21 45 23 45 23 32 39 32 39 45 41 45 41 11 39 11"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 37,
    r: 2,
    fill: "#f1f1f1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#f1f1f1",
    d: "M10 45V43a4 4 0 014-4h0a4 4 0 014 4v2M37 42H33a1 1 0 01-1-1V35a1 1 0 011-1h4a1 1 0 011 1v6A1 1 0 0137 42zm-3-2h2V36H34zM29 42H25a1 1 0 01-1-1V35a1 1 0 011-1h4a1 1 0 011 1v6A1 1 0 0129 42zm-3-2h2V36H26zM48 24H44a1 1 0 01-1-1V15a1 1 0 011-1h4a1 1 0 011 1v8A1 1 0 0148 24zm-3-2h2V16H45z"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 2,
    x: 51,
    y: 14,
    fill: "#de422c"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 2,
    x: 51,
    y: 18,
    fill: "#3f986c"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 2,
    x: 43,
    y: 26,
    fill: "#77787c"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 2,
    x: 43,
    y: 30,
    fill: "#77787c"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 38,
    r: 3,
    fill: "#f9d647"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#999a9e",
    d: "M10,53H54a4,4,0,0,1,4,4v0a0,0,0,0,1,0,0H6a0,0,0,0,1,0,0v0A4,4,0,0,1,10,53Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#b3b4b8",
    d: "M12,55H57.445A3.982,3.982,0,0,0,54,53H10A2,2,0,0,0,12,55Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6,50H17v2H10a5.006,5.006,0,0,0-5,5,1,1,0,0,0,1,1H58a1,1,0,0,0,1-1,5.006,5.006,0,0,0-5-5H47V50H58a5.006,5.006,0,0,0,5-5V11a5.006,5.006,0,0,0-5-5H6a5.006,5.006,0,0,0-5,5V45A5.006,5.006,0,0,0,6,50Zm13,0h2v2H19Zm4,2V50H41v2Zm33.829,4H7.171A3.006,3.006,0,0,1,10,54H54A3.006,3.006,0,0,1,56.829,56ZM45,52H43V50h2ZM3,11A3,3,0,0,1,6,8H58a3,3,0,0,1,3,3V45a3,3,0,0,1-3,3H6a3,3,0,0,1-3-3Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6,46H58a1,1,0,0,0,1-1V11a1,1,0,0,0-1-1H6a1,1,0,0,0-1,1V45A1,1,0,0,0,6,46ZM7,32H21V44H19V43a4.983,4.983,0,0,0-2.52-4.315,3,3,0,1,0-4.96,0A4.983,4.983,0,0,0,9,43v1H7Zm32,0V44H23V32Zm0-2H7V22h5a1,1,0,0,0,.929-.628l.709-1.774,1.378,7.581a1,1,0,0,0,.913.819L16,28a1,1,0,0,0,.949-.684l2.726-8.18.339,2.029A1,1,0,0,0,21,22h4.279l1.772,5.316a1,1,0,0,0,.92.684.977.977,0,0,0,.958-.628l2.851-7.129.25,1A1,1,0,0,0,33,22h6ZM13,37a1,1,0,1,1,1,1A1,1,0,0,1,13,37Zm1,3a3,3,0,0,1,3,3v1H11V43A3,3,0,0,1,14,40Zm43,4H41V12H57ZM39,12v8H33.781l-.811-3.243a1,1,0,0,0-1.9-.129l-2.986,7.466-1.136-3.41A1,1,0,0,0,26,20H21.847l-.861-5.165A1,1,0,0,0,20.078,14a.989.989,0,0,0-1.027.681l-2.765,8.3-1.3-7.16a1,1,0,0,0-1.913-.193L11.323,20H7V12Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33 42h4a1 1 0 001-1V35a1 1 0 00-1-1H33a1 1 0 00-1 1v6A1 1 0 0033 42zm1-6h2v4H34zM25 42h4a1 1 0 001-1V35a1 1 0 00-1-1H25a1 1 0 00-1 1v6A1 1 0 0025 42zm1-6h2v4H26zM44 24h4a1 1 0 001-1V15a1 1 0 00-1-1H44a1 1 0 00-1 1v8A1 1 0 0044 24zm1-8h2v6H45z"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 2,
    x: 51,
    y: 14
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 2,
    x: 51,
    y: 18
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 2,
    x: 43,
    y: 26
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 2,
    x: 43,
    y: 30
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M49,34a4,4,0,1,0,4,4A4,4,0,0,0,49,34Zm0,6a2,2,0,1,1,2-2A2,2,0,0,1,49,40Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVitalRadarIcon);
export default __webpack_public_path__ + "static/media/vitalRadarIcon.ad74ecb092bbc5b227b4942e43c1932d.svg";
export { ForwardRef as ReactComponent };